import React, { useEffect, useState } from "react";
import { Table, Thead, Tbody, Tr, Th, Td, Box, Spinner, useColorModeValue } from "@chakra-ui/react";
import axios from "axios";

const TableWeekly = ({ selectedRetailer, selectedSupplier }) => {
  const [TheadData, setTheadData] = useState([]);
  const [TbodyData, setTbodyData] = useState([]);
  const [loading, setLoading] = useState(true);
  const theadBg = useColorModeValue("gray.50", "gray.700");

  useEffect(() => {
    const fetchTableWeekly = async () => {
      setLoading(true);
      try {
        const res = await axios.post(`${process.env.REACT_APP_API_URL}/rep_strikeRate/get-table-weekly`, {
          retailer: selectedRetailer,
          supplier: selectedSupplier,
        });
        setTheadData(res.data.data.tableData.thead);
        setTbodyData(res.data.data.tableData.tbody);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching weekly table data:", error);
        setLoading(false);
      }
    };

    fetchTableWeekly();
  }, [selectedRetailer, selectedSupplier]);

  function formatDateString(dateString) {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const date = new Date(dateString);
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear().toString().slice(-2);
    return `${day} ${month} '${year}`;
  }

  if (loading) return <Spinner />;

  return (
    <Box maxH="28vh" overflowY="auto">
      <Table variant="striped" size="sm" colorScheme="custom">
        <Thead position="sticky" top={0} zIndex={1} bg={theadBg}>
          {TheadData.map((row, index) => (
            <Tr key={index}>
              <Th fontSize="2xs" whiteSpace="nowrap" px={1} py={0.5}>{row.th1}</Th>
              <Th fontSize="2xs" whiteSpace="nowrap" px={1} py={0.5}>{row.th2}</Th>
              <Th fontSize="2xs" whiteSpace="nowrap" px={1} py={0.5}>{row.th3}</Th>
              <Th fontSize="2xs" whiteSpace="nowrap" px={1} py={0.5}>{row.th4}</Th>
              <Th fontSize="2xs" whiteSpace="nowrap" px={1} py={0.5}>{row.th5}</Th>
            </Tr>
          ))}
        </Thead>
        <Tbody>
          {TbodyData.map((row, index) => (
            <Tr key={index}>
              <Td fontSize="2xs" whiteSpace="nowrap" px={1} py={0.5}>{formatDateString(row.week_ending_date)}</Td>
              <Td fontSize="2xs" whiteSpace="nowrap" px={1} py={0.5}>{row.po_order_qty}</Td>
              <Td fontSize="2xs" whiteSpace="nowrap" px={1} py={0.5}>{row.po_receipt_qty}</Td>
              <Td fontSize="2xs" whiteSpace="nowrap" px={1} py={0.5}>{row.strike_rate}</Td>
              <Td fontSize="2xs" whiteSpace="nowrap" px={1} py={0.5}>{row.value}</Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  );
};

export default TableWeekly;
